import HTTPHandler, { formatResponse } from 'lib/api/HTTPHandler'
import { CONTRACTS_API_URL } from 'lib/api/env'
import { createError } from 'lib/api/serverError'

class CsContractsService {
  static getStatuses = async () => {
    try {
      const res = await HTTPHandler.get(
        CONTRACTS_API_URL + `/contract/statuses`
      )
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }

  static getStatusList = async saleType => {
    try {
      const res = await HTTPHandler.get(
        CONTRACTS_API_URL +
          `/contractsStatuses/getBySaleType?saleType=${saleType}`
      )
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }

  static getContract = async id => {
    try {
      const res = await HTTPHandler.get(CONTRACTS_API_URL + `/contract/${id}`)
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }
  //https://test.asterx.kz/api-cs-contracts/agreement/byGlobalId/193
  static getAgreementByGlobalId = async id => {
    try {
      const res = await HTTPHandler.get(
        CONTRACTS_API_URL + `/agreement/byGlobalId/${id}`
      )
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }
}

export default CsContractsService
